import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-config-identity" }

import { useStore } from 'vuex';
import { LabeledInput } from '@components/Form/LabeledInput';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthConfigIdentity',
  props: {
    name: {},
    description: {},
    nameFixed: { type: Boolean, default: false },
    nameError: { default: null }
  },
  emits: ["update:name", "update:description"],
  setup(__props: any, { emit: __emit }) {

/**
 * The name and description of an auth provider connection.
 *
 * Shown both when adding a provider and when editing one, so that an install
 * with several configs of the same provider can tell them apart. The name is
 * `metadata.name`, which the API rejects on update, so it is only editable
 * before the config exists.
 */


const emit = __emit;

const store = useStore();
const t = (key: string, args?: object) => store.getters['i18n/t'](key, args);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(LabeledInput), {
      value: __props.name,
      label: t('authConfig.create.name.label'),
      required: !__props.nameFixed,
      disabled: __props.nameFixed,
      status: __props.nameError ? 'error' : undefined,
      "sub-label": __props.nameError || '',
      "data-testid": "auth-config-name",
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('update:name', $event)))
    }, null, 8, ["value", "label", "required", "disabled", "status", "sub-label"]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createVNode(_unref(LabeledInput), {
      value: __props.description,
      label: t('authConfig.create.descriptionField.label'),
      placeholder: t('authConfig.create.descriptionField.placeholder'),
      "data-testid": "auth-config-description",
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (emit('update:description', $event)))
    }, null, 8, ["value", "label", "placeholder"])
  ]))
}
}

})